import{j as o}from"./chunk-UATCR5PB.js";import{m as e}from"./chunk-HBP5N4FR.js";e();o();var r=()=>{var t;return(t=(window==null?void 0:window.location.hash).split("/")[2])!=null?t:"raw"};export{r as a};
//# sourceMappingURL=chunk-5ABNHAEW.js.map
